import React from "react";
import BaseHeader from "./BaseHeader";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from "@material-ui/core/Snackbar/Snackbar";
import BaseFooter from "./BaseFooter";

import Button from "components/CustomButtons/Button.js";
import {withStyles} from "@material-ui/core";

import useStyles from "assets/jss/material-kit-pro-react/views/loginPageStyle.js";
import {bingImage} from "../../utils/request";
import intl from "react-intl-universal";

class BaseLayout extends React.Component {


	constructor(props, context) {
		super(props, context);
		this.state = {
			bingImage: '',
			snackbarOpen: true
		};
		this.initData();
	}


	initData = () => {
		bingImage().then(res => {
			this.setState({
				bingImage: "url(" + res.data + ")",
			})
		})
	};


	closeSnackbar = () => {
		this.setState({
			snackbarOpen: false
		})
	};

	changeBackground = () => {
		this.setState({
			bingImage: 'url(https://source.unsplash.com/random/' + Math.floor(Math.random() * 1000) + ')',
		}, () => {
			this.timeoutId = setTimeout(() => {
				this.setState({
					snackbarOpen: true
				})
			}, 3000)
		});
	};


	render() {
		const {classes} = this.props;
		return (
			<div>
				<BaseHeader absolute/>

				<div
					className={classes.pageHeader}
					style={{
						// backgroundImage: "url(\"https://www.bing.com/th?id=OHR.SitkaHarbor_ROW7249741755_1920x1080.jpg&rf=LaDigue_1920x1080.jpg\")",
						backgroundImage: `${this.state.bingImage}`,
						backgroundSize: "cover",
						backgroundPosition: "top center"
					}}
				>

					<div className={classes.container}>
						{this.props.children}
					</div>

					<Snackbar
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'left',
						}}
						open={this.state.snackbarOpen}
						autoHideDuration={0}
						onClick={this.closeSnackbar}
						message={intl.get('change_background')}

						action={
							<React.Fragment>
								<Button color="secondary" size="small"
										onClick={this.changeBackground}>
									{intl.get('change')}
								</Button>
								<IconButton size="small" aria-label="close" color="inherit"
											onClick={this.closeSnackbar}>
									<CloseIcon fontSize="small"/>
								</IconButton>
							</React.Fragment>
						}
					>

					</Snackbar>

				</div>

				<BaseFooter/>
			</div>
		)
	}
}

export default withStyles(useStyles)(BaseLayout)